import { FormEvent } from 'react'
import { useParams } from 'react-router'
import { ObjectTypes, useObjectGet, useObjectUpdate } from '../api/object'
import { ObjectForm } from './object-form'

export function ObjectEditForm({ id, object }: { object: keyof ObjectTypes; id: string }) {
	const { data, isSuccess, dataUpdatedAt } = useObjectGet(object, id)
	const { mutate, isPending } = useObjectUpdate(object, id)

	const onSubmit = (event: FormEvent<HTMLFormElement>) => {
		const form = event.currentTarget
		event.preventDefault()
		mutate(new FormData(form))
	}

	if (!isSuccess) return null

	return (
		<ObjectForm
			key={dataUpdatedAt}
			object={object}
			onSubmit={onSubmit}
			isPending={isPending}
			data={data}
		/>
	)
}

export function ObjectEdit() {
	const { id = '', object } = useParams<{ object: keyof ObjectTypes; id: string }>()
	if (!object) throw new Error('Invalid invocation')

	return <ObjectEditForm id={id} object={object} />
}
